import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import { TextCancelButton, ErrorContainedButton } from '../button';

const ConfirmDeleteDialog = ({
  open,
  onClose,
  onConfirm,
  count = 0,
  itemLabel = 'campaign',
}) => {
  const plural = count === 1 ? itemLabel : `${itemLabel}s`;
  const message =
    count > 0
      ? `Are you sure you want to delete ${count} selected ${plural}?`
      : `Are you sure you want to delete this ${itemLabel}?`;

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {message} This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <TextCancelButton onClick={onClose}>Cancel</TextCancelButton>
        <ErrorContainedButton onClick={onConfirm} autoFocus>
          Delete
        </ErrorContainedButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
